<template>
  <v-card class="section-card" elevation="0">
    <v-form ref="form" class="section-form">
      <div class="password-hero">
        <div class="password-hero-inner">
          <div class="icon-circle">
            <v-icon size="30" color="#2563eb">mdi-lock-reset</v-icon>
          </div>
          <div class="hero-text">
            <div class="hero-title">เปลี่ยนรหัสผ่าน</div>
            <div class="hero-subtitle">
              กรุณากรอกรหัสผ่านเดิม และตั้งรหัสผ่านใหม่ที่ยาวอย่างน้อย
              {{ passwordMin }} ตัวอักษร
            </div>
          </div>
        </div>
      </div>

      <div class="form-section">
        <v-row class="form-grid">
          <v-col cols="12">
            <span class="detail-text">รหัสผ่านเดิม</span>
            <v-text-field
              v-model.trim="form.currentPassword"
              :type="showCurrent ? 'text' : 'password'"
              placeholder="กรอกรหัสผ่านเดิม"
              v-bind="tfProps"
              :rules="currentPasswordRules"
              :append-icon="showCurrent ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showCurrent = !showCurrent"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <span class="detail-text">รหัสผ่านใหม่</span>
            <v-text-field
              v-model.trim="form.newPassword"
              :type="showNew ? 'text' : 'password'"
              placeholder="รหัสผ่านใหม่ (อย่างน้อย 8 ตัวอักษร)"
              v-bind="tfProps"
              :rules="newPasswordRules"
              :append-icon="showNew ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showNew = !showNew"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <span class="detail-text">ยืนยันรหัสผ่านใหม่</span>
            <v-text-field
              v-model.trim="form.confirmPassword"
              :type="showConfirm ? 'text' : 'password'"
              placeholder="พิมพ์รหัสผ่านใหม่อีกครั้ง"
              v-bind="tfProps"
              :rules="confirmPasswordRules"
              :append-icon="showConfirm ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showConfirm = !showConfirm"
            />
          </v-col>
        </v-row>

        <div class="actions">
          <v-btn
            class="btn-secondary"
            height="44"
            outlined
            :disabled="loading"
            @click="reset"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            class="btn-primary"
            height="44"
            :loading="loading"
            :disabled="loading"
            @click="save"
          >
            บันทึก
          </v-btn>
        </div>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import swalAlert from "@/services/alert/swalServices";

export default {
  name: "ProfilePasswordCard",
  props: {
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      passwordMin: 8,
      tfProps: { outlined: true, hideDetails: "auto", dense: true },
      showCurrent: false,
      showNew: false,
      showConfirm: false,
    };
  },

  computed: {
    currentPasswordRules() {
      return [
        (v) => !!v || "กรุณาระบุรหัสผ่านเดิม",
      ];
    },
    newPasswordRules() {
      return [
        (v) => !!v || "กรุณาระบุรหัสผ่านใหม่",
        (v) =>
          String(v || "").length >= this.passwordMin ||
          `รหัสผ่านใหม่ต้องยาวอย่างน้อย ${this.passwordMin} ตัวอักษร`,
      ];
    },
    confirmPasswordRules() {
      return [
        (v) => !!v || "กรุณายืนยันรหัสผ่านใหม่",
        (v) =>
          v === this.form.newPassword ||
          "รหัสผ่านใหม่และยืนยันรหัสผ่านใหม่ต้องตรงกัน",
      ];
    },
  },

  methods: {
    async reset() {
      const res = await swalAlert.Dialog(
        "ยกเลิกการเปลี่ยนรหัสผ่าน",
        "คุณต้องการยกเลิกการกรอกรหัสผ่านใช่หรือไม่?",
        require("@/assets/alert/cancel.png"),
        120,
        120,
        "ยืนยัน",
        "ยกเลิก",
        true
      );

      if (!res.isConfirmed) return;

      this.form = {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      };

      if (this.$refs.form && this.$refs.form.resetValidation) {
        this.$refs.form.resetValidation();
      }

      await swalAlert.Success("ยกเลิกแก้ไขรหัสผ่านสำเร็จ");
    },

    save() {
      const formRef = this.$refs.form;
      if (formRef?.validate && !formRef.validate()) return;

      this.$emit("change-password", { ...this.form });
    },
  },
};
</script>

<style scoped>
.section-card {
  border-radius: 18px;
  border: 1px solid #e5e7f0;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.03);
}
.section-form {
  padding: 20px 24px 20px;
}
.password-hero {
  width: 100%;
  border-radius: 14px;
  padding: 18px 16px 16px;
  background: linear-gradient(180deg, #f7f9ff 0%, #ffffff 60%);
  border: 1px solid #eef2ff;
  margin-bottom: 12px;
}
.password-hero-inner {
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
}
.icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: #e0ecff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero-text {
  flex: 1;
}
.hero-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}
.hero-subtitle {
  font-size: 13px;
  color: #6b7280;
  margin-top: 2px;
}
.form-section {
  margin: 8px auto 0;
  border-top: 1px solid #edf0f4;
  padding-top: 18px;
}
.detail-text {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 4px;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}
.btn-secondary {
  background: #ffffff !important;
  color: #4b5563 !important;
  border-radius: 10px !important;
  min-width: 120px;
  border: 1px solid #d1d5db !important;
}
.btn-primary {
  background: #2563eb !important;
  color: #ffffff !important;
  border-radius: 10px !important;
  min-width: 160px;
}
:deep(.v-input) {
  margin-bottom: 10px !important;
}
:deep(.v-input--dense .v-input__slot) {
  min-height: 44px !important;
  height: 44px !important;
  padding: 0 10px !important;
  border-radius: 10px !important;
  border-color: #e5e7eb !important;
  background: #ffffff !important;
}
:deep(.v-text-field.v-input--dense input) {
  height: 24px !important;
  line-height: 24px !important;
  padding: 0 !important;
  font-size: 14px !important;
}
@media (max-width: 600px) {
  .section-form {
    padding: 18px 14px 18px;
  }
  .password-hero-inner {
    align-items: flex-start;
  }
}
</style>